import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import classNames from 'classnames';

import { Switch, Route, Link, withRouter, useRouteMatch, useParams, useLocation } from 'react-router-dom';
import { fetchShopOverview, fetchProduct } from '../../actions';
import { find } from 'lodash';

// MODULES
import Modules from '../modules/Modules';

import Collection from '../modules/Collection';
import Image from '../modules/Image';
import Stage from '../modules/Stage';
import Video from '../modules/Video';

// PARTS
import Product from '../parts/Product';
import { ShopNewsletterForm as NewsletterForm } from '../parts/NewsletterForm';

const ShopFooter = props => {
  return (
    <footer className="footer footer--shop">
      <div className="inner inner--flex">
        <ul className="menu">
          <li>
            <Link to="/shop/faq">FAQ</Link>
          </li>
          <li>
            <Link to="/shop/terms">Terms & Conditions</Link>
          </li>
          <li>
            <a href="/imprint.txt" target="_blank">
              Imprint
            </a>
          </li>
        </ul>

        <NewsletterForm />
      </div>
    </footer>
  );
}
const Shop = props => {
  const match = useRouteMatch();
  const location = useLocation();

  useEffect(() => {
    document.body.classList.add('white');

    return function cleanup(){
      document.body.classList.remove('white');
    }
  }, []);

  return (
    <div className={classNames('shop transition', {
      'shop--ready': props.shop
    })}>
      {props.shop &&
        <Modules modules={props.shop}/>
      }

      <ShopFooter />
    </div>
  );
}


const mapStateToProps = (state, ownProps) => {
  return {
    shop: state.shop.shop,
    products: state.products.products
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchShopOverview: () => {
      dispatch(fetchShopOverview());
    },
    fetchProduct: () => {
      dispatch(fetchProduct());
    },
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Shop));
